var _circle, _path, _ellipse, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMusicBandMusicNoteGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#D5D8DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5515 11.8886C43.5515 10.8456 44.3971 10 45.4402 10H51.1894C55.0084 11.7822 63.41 14.9646 66.4652 13.437C70.2841 11.5276 67.6109 23.7482 51.1894 26.0396V56.5911H51.1292C51.1691 57.095 51.1894 57.6045 51.1894 58.1187C51.1894 68.6644 42.6404 74.5401 32.0947 74.5401C21.549 74.5401 13 68.6644 13 58.1187C13 47.5729 21.549 39.024 32.0947 39.024C36.3933 39.024 40.3602 40.4444 43.5515 42.8415V11.8886Z",
    fill: "#505862"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.9384,
    cy: 52.2507,
    rx: 5.72841,
    ry: 6.4922,
    fill: "#F1F2F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1792 52.3901C48.1792 55.9757 45.9565 58.0102 43.2146 58.0102C40.4727 58.0102 38.25 55.9757 38.25 52.3901C38.25 48.8046 40.4727 45.8979 43.2146 45.8979C45.9565 45.8979 48.1792 48.8046 48.1792 52.3901Z",
    fill: "#F1F2F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0304 59.6462H40.8287C41.4386 59.6462 41.8808 60.2178 41.6169 60.7677C41.0142 62.0237 39.8138 63.4652 37.8454 63.4652C34.5754 63.4652 32.7587 59.6462 34.0304 59.6462Z",
    fill: "#B9BEC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9061 53.7471C34.6198 54.0536 35.7066 54.1871 35.8519 53.4242C35.8919 53.2141 35.9129 52.9959 35.9129 52.7722C35.9129 51.0849 34.7158 49.717 33.2397 49.717C31.7636 49.717 30.5664 51.0849 30.5664 52.7722C30.5664 52.8292 30.5678 52.8859 30.5705 52.9422C30.6046 53.6536 31.5262 53.7784 32.2186 53.6112C32.4215 53.5622 32.6359 53.536 32.8578 53.536C33.2356 53.536 33.592 53.6122 33.9061 53.7471Z",
    fill: "#505862"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6932 53.595C46.422 53.7499 47.403 53.5901 47.4161 52.8451C47.4165 52.8209 47.4167 52.7966 47.4167 52.7722C47.4167 51.0849 46.3911 49.717 45.1253 49.717C43.8596 49.717 42.834 51.0849 42.834 52.7722C42.834 52.7966 42.8342 52.8209 42.8346 52.8451C42.8477 53.5901 43.8287 53.7499 44.5575 53.595C44.7391 53.5565 44.9293 53.536 45.1253 53.536C45.3214 53.536 45.5116 53.5565 45.6932 53.595Z",
    fill: "#505862"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMusicBandMusicNoteGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MusicBandMusicNoteGray.278c481843432eca22f1551411f1eab9.svg";